import React from 'react';
import ViewportList from '../../components/ViewportList';
import Layout from '../../components/Layout';
import axios from 'axios';
import baseApiUrl from '../../utils/baseApiUrl';

export default function Viewport() {
  const [token, setToken] = React.useState(null)
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
      if (window) { 
         let t = window.localStorage.getItem('token')
         
         if (t == null) {
             window.location.href = '/login'
         } else {
              setToken(t)
              setShow(true)
         }

      }
  }, []);

  let mockups = (
    <Layout>
      <h1>Viewports</h1>
      <ViewportList token={token}/>
    </Layout>
  )
  return (
    <>{show ? mockups : null}</>
  );
}
